<script lang="ts">
    import { Button, Loading, Slider } from "attractions";
    import { throttle } from "../utils/common";

    export let solveInProgress: boolean;
    export let onReset: () => void;
    export let onShuffle: () => void;
    export let onRun: (steps: number) => void;
    export let onSolve: () => void;

    let steps = 50;

    const THROTTLE_DURATION = 500; // in ms

    const onResetThrottled = throttle(onReset, THROTTLE_DURATION);
    const onShuffleThrottled = throttle(onShuffle, THROTTLE_DURATION);
    const onRunThrottled = throttle(onRun, THROTTLE_DURATION);
    const onSolveThrottled = throttle(onSolve, THROTTLE_DURATION);
</script>

<div class="root-container">
    <div class="button-group-container">
        <div class="reset-container">
            <Button outline on:click={onResetThrottled} class="reset-btn"
                >Reset</Button
            >
        </div>
        <div class="shuffle-container">
            <Button outline on:click={onShuffleThrottled} class="shuffle-btn"
                >Shuffle</Button
            >
        </div>
    </div>

    <div class="button-group-container">
        <div>
            <Button outline on:click={() => onRunThrottled(steps)}>
                <div class="run-btn-text-container">
                    Run {steps} Steps
                </div>
            </Button>
            <div class="slider-container">
                <Slider
                    bind:value={steps}
                    min={10}
                    max={100}
                    step={10}
                    ticks={{
                        mode: "step",
                        step: 10,
                        subDensity: 11,
                    }}
                />
            </div>
        </div>

        <Button filled on:click={onSolveThrottled}>
            <div class="spinner-container">
                {#if solveInProgress}
                    <Loading class="loading-spinner" />
                {:else}
                    Solve
                {/if}
            </div>
        </Button>
    </div>
</div>

<style lang="scss">
    @use "sass:color";
    @import "theme.scss";

    .run-btn-text-container {
        min-width: 100px;
    }

    .slider-container {
        padding: 0.5rem 1rem 0.5rem 1rem;
    }

    .root-container {
        width: 100%;
        border-radius: 1.618rem;
        display: flex;
        flex-direction: row;
        justify-content: center;
        gap: 1rem;
    }

    .button-group-container {
        display: flex;
        align-items: flex-start;
        gap: 0.5rem;
    }

    .spinner-container {
        min-width: 38px;
        min-height: 20px;
        display: flex;
        justify-content: center;
        :global(.loading-spinner) {
            color: $background !important;
        }
    }

    .reset-container,
    .shuffle-container {
        :global(.reset-btn),
        :global(.shuffle-btn) {
            border-color: $accent !important;
            color: $accent !important;

            &:hover:not([disabled]) {
                background: color.adjust($accent, $alpha: -0.95) !important;
            }

            &:focus:not([disabled]) {
                background: color.adjust($accent, $alpha: -0.88) !important;
            }
        }
    }

    :global(.reset-container .reset-btn .ripple-container .ripple),
    :global(.shuffle-container .shuffle-btn .ripple-container .ripple) {
        background: color.adjust($accent, $alpha: -0.9) !important;
    }
</style>
